import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader from "components/Loader";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import WellnessService from "services/WellnessService";

const TRIVIA_STATUS = {
  ACTIVE: 1,
  SCHEDULED: 2,
  INACTIVE: 0,
};

export default ({ data, listRefresh, setCloseTrivia, setViewTrivia }) => {
  const [quess, setQuess] = useState([]);
  const [loading, setLoading] = useState(false);
  const params = useParams();

  useEffect(() => {
    setLoading(true);
    setQuess([]);
    WellnessService.getIndividualTriviaQuestions(params.teamId, data.id).then(
      (res) => {
        setQuess(
          res.data.map((e) => ({
            ...e,
            isCustomCreated: 0,
            correctAnswer: e.answer
              ? e.options.filter((o) => o.id === e.answer.option_id)?.[0]
                  ?.option
              : "",
          })) || []
        );
        setLoading(false);
      }
    );
  }, [data.id, listRefresh, params.teamId]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center p-3">
        <Loader />
      </div>
    );
  }
  if (quess.length === 0) {
    return (
      <div className="d-flex justify-content-center p-3">
        Please add questions to this trivia
      </div>
    );
  }
  return (
    <div className="list-group list-group-flush">
      {quess.map((row) => (
        <div className="list-group-item">
          <h6>{row.question}</h6>
          <div className="list-group mt-1">
            {row.options.map((opt) => (
              <div
                className="list-group-item"
                style={
                  row.correctAnswer === opt.option &&
                  data.status === TRIVIA_STATUS.INACTIVE
                    ? { background: "#00800036" }
                    : {}
                }
              >
                {opt.option}
              </div>
            ))}
          </div>
        </div>
      ))}
      {quess.length > 0 &&
        (data.status === TRIVIA_STATUS.ACTIVE ||
          data.status === TRIVIA_STATUS.SCHEDULED) && (
          <div className="mt-3 d-flex align-items-center justify-content-between">
            <div>
              <span
                class="d-inline-block"
                tabindex="0"
                data-toggle="tooltip"
                title="You need to first close this trivia, in order to view the members
            responses."
              >
                <FontAwesomeIcon icon={faInfoCircle} fontSize="1rem" />
              </span>
            </div>
            <button
              type="submit"
              className="btn btn-danger btn-sm"
              style={{ marginRight: "10px" }}
              onClick={() => setCloseTrivia(true)}
            >
              Close Trivia
            </button>
          </div>
        )}

      {quess.length > 0 && data.status === TRIVIA_STATUS.INACTIVE && (
        <div className="mt-3 d-flex justify-content-end">
          <button
            type="submit"
            className="btn btn-info btn-sm"
            style={{ marginRight: "10px" }}
            onClick={() => setViewTrivia(true)}
          >
            View Responses
          </button>
        </div>
      )}
    </div>
  );
};
